import React from 'react';
import './index.scss';

const PcModalBack = ({
  modalBackIsEnable,
}) =>{
  if(modalBackIsEnable){
    return(
      <div className="PcModalBack"> </div>
    );
  }
  return null; 
};
export default PcModalBack;